import { Link } from 'react-router-dom';
import { FunctionComponent } from 'react';

type Props = {
  route: string;
}
export const NavLink: FunctionComponent<Props> = ({ route, children }) => <Link to={route} className="rounded-md py-2 px-3 text-sm font-medium text-white hover:bg-light-blue-400">{children}</Link>;
